module.exports = __webpack_public_path__ + "static/flooring-design-min-7598755d3c47393932296549b163eadd.png";